import { css } from 'styled-components';
import token from 'styled-token';
import { StyledIcon } from '../../components/Icon/Icon.styles';
import { StyledImage } from '../../components/Image/Image.styles';
import { T_SHIRT_SIZES } from '../../constants';
import { getInitials } from '../../util/getInitials';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { mediaQueryMixin } from '../mediaQueryMixin';
import { spacingMixin } from '../spacingMixin';
import { typographyMixin } from '../typographyMixin';
var sizeCSS = inlineMediaQueryMixin('size', function (mediaProps) {
  var children = mediaProps.children,
    fullName = mediaProps.fullName,
    tshirt = mediaProps.size;
  return token({
    size: "Avatar.sizes." + tshirt,
    fontType: "Avatar.fontTypes." + tshirt
  }, function (_ref) {
    var size = _ref.size,
      fontType = _ref.fontType;
    var content;
    if (typeof children === 'undefined') {
      var initials = getInitials(fullName);
      // One letter for xs, sm, md sizes
      if (tshirt === T_SHIRT_SIZES.xs || tshirt === T_SHIRT_SIZES.sm || tshirt === T_SHIRT_SIZES.md) {
        initials = initials.charAt(0);
      }
      content = css(["&:after{content:'", "';}"], initials);
    }
    return css(["width:", "px;max-width:100%;aspect-ratio:1/1;", " ", " > ", "{height:", "px;width:", "px;}> ", "{height:100%;width:100%;object-fit:cover;}"], size, typographyMixin(Object.assign({
      fontColor: null /* color handled separately */,
      fontType: fontType,
      fontTypeIconAlignment: false
    }, mediaProps)), content, StyledIcon, size / 2, size / 2, StyledImage);
  })(mediaProps);
});
var colorCSS = function colorCSS(props) {
  var background = props.background;
  return token({
    colors: 'colors',
    iconColorOnLight: 'Avatar.iconColorOnLight',
    iconColorOnDark: 'Avatar.iconColorOnDark',
    defaultBackgroundColor: 'Avatar.defaultBackgroundColor',
    defaultColor: 'Avatar.defaultColor',
    colorOnLight: 'Avatar.colorOnLight',
    colorOnDark: 'Avatar.colorOnDark'
  }, function (_ref2) {
    var colors = _ref2.colors,
      defaultBackgroundColor = _ref2.defaultBackgroundColor,
      iconColorOnLight = _ref2.iconColorOnLight,
      iconColorOnDark = _ref2.iconColorOnDark,
      colorOnLight = _ref2.colorOnLight,
      colorOnDark = _ref2.colorOnDark;
    if (!colors) {
      return '';
    }
    return css(["background-color:", ";color:", ";> ", "{color:", ";}"], background ? colors[background] : defaultBackgroundColor, background === 'gray200' ? colorOnLight : colorOnDark, StyledIcon, background === 'gray200' ? iconColorOnLight : iconColorOnDark);
  })(props);
};

/** @class AvatarMixin */
/** @method */
export var AvatarMixin = function AvatarMixin(props) {
  return token('Avatar.borderRadius', function (borderRadius) {
    return css(["overflow:hidden;display:inline-flex;justify-content:center;align-items:center;border-radius:", ";", " ", " ", " ", ""], borderRadius || '50%', sizeCSS(props), mediaQueryMixin(function (mediaProps) {
      return sizeCSS(Object.assign({}, props, mediaProps));
    }), colorCSS(props), spacingMixin(props));
  })(props);
};